/* Rekover FX : dégradé animé + logo métal liquide.
   Shaders adaptés de Paper Shaders (https://shaders.paper.design), licence Apache 2.0. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var VERT = '#version 300 es\nin vec2 a_pos;uniform float u_aspect;out vec2 v_objectUV;out vec2 v_imageUV;\n' +
    'void main(){gl_Position=vec4(a_pos,0.,1.);vec2 p=a_pos*.5;if(u_aspect>1.){p.y/=u_aspect;}else{p.x*=u_aspect;}' +
    'v_objectUV=p;v_imageUV=vec2(a_pos.x*.5+.5,.5-a_pos.y*.5);}';

  var COMMON = '#define TWO_PI 6.28318530718\n#define PI 3.14159265358979323846\n' +
    'vec2 rotate(vec2 uv,float th){return mat2(cos(th),sin(th),-sin(th),cos(th))*uv;}\n';

  /* ---------- Mesh gradient (Paper) ---------- */
  var MESH = '#version 300 es\nprecision mediump float;\nuniform float u_time;uniform vec4 u_colors[8];uniform float u_colorsCount;' +
    'uniform float u_distortion;uniform float u_swirl;uniform float u_grainOverlay;in vec2 v_objectUV;out vec4 fragColor;\n' + COMMON +
    'float hash21(vec2 p){p=fract(p*vec2(.3183099,.3678794))+.1;p+=dot(p,p+19.19);return fract(p.x*p.y);}\n' +
    'float valueNoise(vec2 st){vec2 i=floor(st);vec2 f=fract(st);float a=hash21(i);float b=hash21(i+vec2(1.,0.));' +
    'float c=hash21(i+vec2(0.,1.));float d=hash21(i+vec2(1.,1.));vec2 u=f*f*(3.-2.*f);return mix(mix(a,b,u.x),mix(c,d,u.x),u.y);}\n' +
    'vec2 getPosition(int i,float t){float a=float(i)*.37;float b=.6+fract(float(i)/3.)*.9;float c=.8+fract(float(i+1)/4.);' +
    'return .5+.5*vec2(sin(t*b+a),cos(t*c+a*1.5));}\n' +
    'void main(){vec2 uv=v_objectUV+.5;vec2 grainUV=gl_FragCoord.xy*1.5;float t=.5*(u_time+41.5);' +
    'float radius=smoothstep(0.,1.,length(uv-.5));float center=1.-radius;' +
    'for(float i=1.;i<=2.;i++){uv.x+=u_distortion*center/i*sin(t+i*.4*smoothstep(0.,1.,uv.y))*cos(.2*t+i*2.4*smoothstep(0.,1.,uv.y));' +
    'uv.y+=u_distortion*center/i*cos(t+i*2.*smoothstep(0.,1.,uv.x));}' +
    'vec2 r=uv-.5;r=rotate(r,-3.*u_swirl*radius)+.5;vec3 color=vec3(0.);float tw=0.;' +
    'for(int i=0;i<8;i++){if(i>=int(u_colorsCount))break;vec2 pos=getPosition(i,t);float dist=pow(length(r-pos),3.5);' +
    'float w=1./(dist+1e-3);color+=u_colors[i].rgb*w;tw+=w;}color/=max(1e-4,tw);' +
    'if(u_grainOverlay>0.){float g=valueNoise(rotate(grainUV,1.)+vec2(3.));g=mix(g,valueNoise(rotate(grainUV,2.)+vec2(-1.)),.5);' +
    'g=pow(g,1.3);float gv=g*2.-1.;float gs=pow(u_grainOverlay*abs(gv),.8);color=mix(color,vec3(step(0.,gv)),.35*gs);}' +
    'color+=1./256.*(fract(sin(dot(.014*gl_FragCoord.xy,vec2(12.9898,78.233)))*43758.5453123)-.5);' +
    'fragColor=vec4(color,1.);}';

  /* ---------- Liquid metal (Paper), version image uniquement ---------- */
  var METAL = '#version 300 es\nprecision highp float;\nuniform sampler2D u_image;uniform vec2 u_resolution;uniform float u_time;' +
    'uniform vec4 u_colorTint;uniform vec4 u_colorAccent;uniform float u_sharp;uniform float u_gamma;uniform float u_gain;uniform float u_softness;uniform float u_repetition;uniform float u_shiftRed;uniform float u_shiftBlue;' +
    'uniform float u_distortion;uniform float u_contour;uniform float u_angle;in vec2 v_imageUV;out vec4 fragColor;\n' + COMMON +
    'vec3 permute(vec3 x){return mod(((x*34.)+1.)*x,289.);}\n' +
    'float snoise(vec2 v){const vec4 C=vec4(.211324865405187,.366025403784439,-.577350269189626,.024390243902439);' +
    'vec2 i=floor(v+dot(v,C.yy));vec2 x0=v-i+dot(i,C.xx);vec2 i1=(x0.x>x0.y)?vec2(1.,0.):vec2(0.,1.);vec4 x12=x0.xyxy+C.xxzz;x12.xy-=i1;' +
    'i=mod(i,289.);vec3 p=permute(permute(i.y+vec3(0.,i1.y,1.))+i.x+vec3(0.,i1.x,1.));' +
    'vec3 m=max(.5-vec3(dot(x0,x0),dot(x12.xy,x12.xy),dot(x12.zw,x12.zw)),0.);m=m*m;m=m*m;vec3 x=2.*fract(p*C.www)-1.;' +
    'vec3 h=abs(x)-.5;vec3 ox=floor(x+.5);vec3 a0=x-ox;m*=1.79284291400159-.85373472095314*(a0*a0+h*h);vec3 g;' +
    'g.x=a0.x*x0.x+h.x*x0.y;g.yz=a0.yz*x12.xz+h.yz*x12.yw;return 130.*dot(m,g);}\n' +
    'float getColorChanges(float c1,float c2,float sp,vec3 w,float blur,float bump,float tint,float ta){' +
    'float ch=mix(c2,c1,smoothstep(0.,2.*blur,sp));float border=w[0];ch=mix(ch,c2,smoothstep(border,border+2.*blur,sp));' +
    'bump=smoothstep(.2,.8,bump);border=w[0]+.4*(1.-bump)*w[1];ch=mix(ch,c1,smoothstep(border,border+2.*blur,sp));' +
    'border=w[0]+.5*(1.-bump)*w[1];ch=mix(ch,c2,smoothstep(border,border+2.*blur,sp));' +
    'border=w[0]+w[1];ch=mix(ch,c1,smoothstep(border,border+2.*blur,sp));' +
    'float gt=(sp-w[0]-w[1])/w[2];float gr=mix(c1,c2,smoothstep(0.,1.,gt));ch=mix(ch,gr,smoothstep(border,border+.5*blur,sp));' +
    'ch=mix(ch,1.-min(1.,(1.-ch)/max(tint,.0001)),ta);return ch;}\n' +
    'float blurEdge3x3(vec2 uv,vec2 dx,vec2 dy,float radius,float cs){vec2 r=radius/vec2(textureSize(u_image,0));float s=4.*cs;' +
    's+=2.*textureGrad(u_image,uv+vec2(0.,-r.y),dx,dy).r;s+=2.*textureGrad(u_image,uv+vec2(0.,r.y),dx,dy).r;' +
    's+=2.*textureGrad(u_image,uv+vec2(-r.x,0.),dx,dy).r;s+=2.*textureGrad(u_image,uv+vec2(r.x,0.),dx,dy).r;' +
    's+=textureGrad(u_image,uv+vec2(-r.x,-r.y),dx,dy).r;s+=textureGrad(u_image,uv+vec2(r.x,-r.y),dx,dy).r;' +
    's+=textureGrad(u_image,uv+vec2(-r.x,r.y),dx,dy).r;s+=textureGrad(u_image,uv+vec2(r.x,r.y),dx,dy).r;return s/16.;}\n' +
    'void main(){float t=.3*(u_time+2.8);vec2 uv=v_imageUV;vec2 dx=dFdx(uv);vec2 dy=dFdy(uv);vec4 img=textureGrad(u_image,uv,dx,dy);' +
    'float cw=u_repetition;vec2 ru=uv-.5;float an=(-u_angle+70.)*PI/180.;ru=vec2(ru.x*cos(an)-ru.y*sin(an),ru.x*sin(an)+ru.y*cos(an))+.5;' +
    'float edge=blurEdge3x3(uv,dx,dy,6.,img.r);edge=pow(edge,1.6);edge*=smoothstep(0.,.4,u_contour);float opacity=img.g;' +
    'float dB=ru.x-ru.y;float dT=ru.x+ru.y;vec3 c1=vec3(.98,.98,1.);vec3 c2=vec3(.1,.1,.1+.1*smoothstep(.7,1.3,dT));' +
    'vec2 gu=uv-.5;float dist=length(gu+vec2(0.,.2*dB));gu=rotate(gu,(.25-.2*dB)*PI);float dir=gu.x;' +
    'float bump=1.-pow(1.8*dist,1.2);bump*=pow(uv.y,.3);' +
    'float t1=.12/cw*(1.-.4*bump);float t2=.07/cw*(1.+.4*bump);float wr=1.-t1-t2;' +
    'float n=snoise(uv-t);edge+=(1.-edge)*u_distortion*n;dir+=dB;' +
    'dir-=2.*n*dB*(smoothstep(0.,1.,edge)*(1.-smoothstep(0.,1.,edge)));' +
    'dir*=mix(1.,1.-edge,smoothstep(.5,1.,u_contour));dir-=1.7*edge*smoothstep(.5,1.,u_contour);' +
    'dir+=.2*pow(u_contour,4.)*(1.-smoothstep(0.,1.,edge));bump*=clamp(pow(uv.y,.1),.3,1.);dir*=(.1+(1.1-edge)*bump);' +
    'dir*=(.4+.6*(1.-smoothstep(.5,1.,edge)));dir+=.18*(smoothstep(.1,.2,uv.y)*(1.-smoothstep(.2,.4,uv.y)));' +
    'dir+=.03*(smoothstep(.1,.2,1.-uv.y)*(1.-smoothstep(.2,.4,1.-uv.y)));dir*=(.5+.5*pow(uv.y,2.));dir*=cw;dir-=t;' +
    'float cd=clamp(1.-bump,0.,1.);float dR=cd+.03*bump*n;' +
    'dR+=5.*(smoothstep(-.1,.2,uv.y)*(1.-smoothstep(.1,.5,uv.y)))*(smoothstep(.4,.6,bump)*(1.-smoothstep(.4,1.,bump)));dR-=dB;' +
    'float dBl=cd*1.3;dBl+=(smoothstep(0.,.4,uv.y)*(1.-smoothstep(.1,.8,uv.y)))*(smoothstep(.4,.6,bump)*(1.-smoothstep(.4,.8,bump)));' +
    'dBl-=.2*edge;dR*=(u_shiftRed/20.);dBl*=(u_shiftBlue/20.);' +
    'float soft=.05*u_softness;float blur=soft+.5*smoothstep(1.,10.,u_repetition)*smoothstep(0.,1.,edge);' +
    'blur+=(1.-u_sharp)*(1.-smoothstep(100.,500.,min(u_resolution.x,u_resolution.y)))*smoothstep(0.,1.,edge);' +
    'float rX=soft*(.05+.1*(u_shiftRed/20.)*bump);float gX=soft*.05/max(.001,abs(1.-dB));' +
    'vec4 tn=mix(u_colorTint,u_colorAccent,step(.5,1.-img.b));vec3 w=vec3(cw*t1,cw*t2,wr);w[1]-=.02*smoothstep(0.,1.,edge+bump);' +
    'float sr=fract(dir+dR);float r=getColorChanges(c1.r,c2.r,sr,w,blur+fwidth(sr)+rX,bump,tn.r,tn.a);' +
    'float sg=fract(dir);float g=getColorChanges(c1.g,c2.g,sg,w,blur+fwidth(sg)+gX,bump,tn.g,tn.a);' +
    'float sb=fract(dir-dBl);float b=getColorChanges(c1.b,c2.b,sb,w,blur+fwidth(sb),bump,tn.b,tn.a);' +
    'vec3 color=pow(vec3(r,g,b),vec3(max(u_gamma,.01)))*u_gain*opacity;' +
    'color+=1./256.*(fract(sin(dot(.014*gl_FragCoord.xy,vec2(12.9898,78.233)))*43758.5453123)-.5)*opacity;' +
    'fragColor=vec4(color,opacity);}';

  function hex(c, a) {
    c = c.replace('#', '');
    if (c.length === 3) c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2];
    var n = parseInt(c, 16);
    return [(n >> 16 & 255) / 255, (n >> 8 & 255) / 255, (n & 255) / 255, a == null ? 1 : a];
  }

  /* ---------- Petit moteur WebGL2 ---------- */
  function Fx(el, frag, opts) {
    var canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    canvas.className = 'fx-canvas';
    var gl = canvas.getContext('webgl2', { antialias: false, depth: false, stencil: false, premultipliedAlpha: true, alpha: true });
    if (!gl) throw new Error('webgl2');
    function sh(type, src) {
      var s = gl.createShader(type); gl.shaderSource(s, src); gl.compileShader(s);
      if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) throw new Error(gl.getShaderInfoLog(s));
      return s;
    }
    var prog = gl.createProgram();
    gl.attachShader(prog, sh(gl.VERTEX_SHADER, VERT));
    gl.attachShader(prog, sh(gl.FRAGMENT_SHADER, frag));
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) throw new Error(gl.getProgramInfoLog(prog));
    gl.useProgram(prog);
    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, 'a_pos');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

    var self = this;
    this.gl = gl; this.canvas = canvas; this.prog = prog;
    this.speed = reduce ? 0 : (opts.speed == null ? 1 : opts.speed);
    this.res = opts.res || 1;
    this.time = opts.frame || 0;
    this.visible = true; this.ready = !opts.wait; this.dirty = true;
    this.u = function (name) { return gl.getUniformLocation(prog, name); };
    el.appendChild(canvas);

    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, opts.maxDpr || 2) * self.res;
      var w = Math.max(1, Math.round(el.clientWidth * dpr)), h = Math.max(1, Math.round(el.clientHeight * dpr));
      var max = opts.maxPixels || 2.6e6, k = Math.min(1, Math.sqrt(max / (w * h)));
      w = Math.round(w * k); h = Math.round(h * k);
      if (canvas.width !== w || canvas.height !== h) {
        canvas.width = w; canvas.height = h;
        gl.viewport(0, 0, w, h);
        gl.uniform2f(self.u('u_resolution'), w, h);
        gl.uniform1f(self.u('u_aspect'), w / h);
        self.dirty = true;
      }
    }
    this.size = size;
    size();
    if (window.ResizeObserver) new ResizeObserver(size).observe(el); else window.addEventListener('resize', size);
    if (window.IntersectionObserver) new IntersectionObserver(function (e) { self.visible = e[0].isIntersecting; }).observe(el);

    var last = performance.now(), minDt = opts.fps ? 1000 / opts.fps - 2 : 0;
    function frame(now) {
      if (now - last < minDt) { requestAnimationFrame(frame); return; }
      var dt = Math.min(64, now - last); last = now;
      if (self.ready && self.visible && !document.hidden && (self.speed || self.dirty)) {
        self.time += dt * 0.001 * self.speed;
        gl.uniform1f(self.u('u_time'), self.time);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
        if (self.dirty) { self.dirty = false; el.classList.add('fx-ready'); }
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ---------- Préparation du masque du logo (méthode Paper : équation de Poisson) ---------- */
  function processMask(src, accent) {
    var W = src.width, H = src.height;
    var data = src.getContext('2d').getImageData(0, 0, W, H).data;
    var N = W * H, shape = new Uint8Array(N), u = new Float32Array(N);
    for (var i = 0; i < N; i++) shape[i] = data[i * 4 + 3] ? 1 : 0;
    var red = [], black = [];
    for (var y = 1; y < H - 1; y++) for (var x = 1; x < W - 1; x++) {
      var k = y * W + x;
      if (!shape[k]) continue;
      if (!shape[k - 1] || !shape[k + 1] || !shape[k - W] || !shape[k + W] || !shape[k - W - 1] || !shape[k - W + 1] || !shape[k + W - 1] || !shape[k + W + 1]) continue;
      ((x + y) % 2 ? black : red).push(k);
    }
    function pass(list) {
      for (var j = 0; j < list.length; j++) {
        var q = list[j];
        var s = (shape[q + 1] ? u[q + 1] : 0) + (shape[q - 1] ? u[q - 1] : 0) + (shape[q - W] ? u[q - W] : 0) + (shape[q + W] ? u[q + W] : 0);
        u[q] = 1.9 * ((0.01 + s) / 4) - 0.9 * u[q];
      }
    }
    for (var it = 0; it < 40; it++) { pass(red); pass(black); }
    var max = 1e-6;
    for (i = 0; i < N; i++) if (u[i] > max) max = u[i];
    var out = new Uint8Array(N * 4);
    for (i = 0; i < N; i++) {
      var a = data[i * 4 + 3];
      out[i * 4] = a ? Math.round(255 * (1 - u[i] / max)) : 255;
      out[i * 4 + 1] = a;
      out[i * 4 + 2] = accent && accent[i * 4 + 3] > 40 ? 0 : 255; out[i * 4 + 3] = 255;
    }
    return { w: W, h: H, px: out };
  }

  /* ---------- Initialisation ---------- */
  function initMesh(el) {
    var colors = (el.getAttribute('data-colors') || '#EEF1F2,#C9D3D7,#E6D3AE,#8FA1A8,#F7F3EA').split(',');
    var fx = new Fx(el, MESH, { speed: parseFloat(el.getAttribute('data-speed') || '0.3'), res: parseFloat(el.getAttribute('data-res') || '0.5'), maxDpr: 1.5, maxPixels: parseFloat(el.getAttribute('data-max') || '9e5'), fps: parseFloat(el.getAttribute('data-fps') || '0') || 0, frame: 12 });
    var gl = fx.gl, flat = [];
    colors.slice(0, 8).forEach(function (c) { flat = flat.concat(hex(c.trim())); });
    while (flat.length < 32) flat.push(0);
    gl.uniform4fv(fx.u('u_colors'), new Float32Array(flat));
    gl.uniform1f(fx.u('u_colorsCount'), Math.min(8, colors.length));
    gl.uniform1f(fx.u('u_distortion'), parseFloat(el.getAttribute('data-distortion') || '0.8'));
    gl.uniform1f(fx.u('u_swirl'), parseFloat(el.getAttribute('data-swirl') || '0.15'));
    gl.uniform1f(fx.u('u_grainOverlay'), parseFloat(el.getAttribute('data-grain') || '0.12'));
  }

  function metal(el, mk, o) {
    var fx = new Fx(el, METAL, { speed: o.speed, maxDpr: 2, maxPixels: o.maxPixels || 2.2e6, wait: true });
    var gl = fx.gl, tex = gl.createTexture();
    gl.activeTexture(gl.TEXTURE0);
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, mk.w, mk.h, 0, gl.RGBA, gl.UNSIGNED_BYTE, mk.px);
    gl.generateMipmap(gl.TEXTURE_2D);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.uniform1i(fx.u('u_image'), 0);
    gl.uniform4fv(fx.u('u_colorTint'), hex(o.tint, o.tintA == null ? 1 : o.tintA));
    gl.uniform4fv(fx.u('u_colorAccent'), hex(o.accent || o.tint, 1));
    gl.uniform1f(fx.u('u_sharp'), o.sharp || 0);
    gl.uniform1f(fx.u('u_gamma'), o.gamma || 1);
    gl.uniform1f(fx.u('u_gain'), o.gain || 1);
    gl.uniform1f(fx.u('u_softness'), o.softness);
    gl.uniform1f(fx.u('u_repetition'), o.repetition);
    gl.uniform1f(fx.u('u_shiftRed'), o.shift);
    gl.uniform1f(fx.u('u_shiftBlue'), o.shift);
    gl.uniform1f(fx.u('u_distortion'), o.distortion);
    gl.uniform1f(fx.u('u_contour'), o.contour);
    gl.uniform1f(fx.u('u_angle'), o.angle);
    fx.size();
    fx.ready = true; fx.dirty = true;
    return fx;
  }

  function initMetal(el) {
    var text = el.getAttribute('data-text') || 'REKOVER';
    var font = el.getAttribute('data-font') || 'Anton';
    var go = function () {
      var H = 512, pad = H * 0.08;
      var c = document.createElement('canvas'), ctx = c.getContext('2d');
      var fs = H * 0.9;
      ctx.font = '400 ' + fs + 'px "' + font + '", Impact, sans-serif';
      var m = ctx.measureText(text);
      var asc = m.actualBoundingBoxAscent || fs * 0.75, desc = m.actualBoundingBoxDescent || 0;
      fs *= (H - 2 * pad) / (asc + desc);
      ctx.font = '400 ' + fs + 'px "' + font + '", Impact, sans-serif';
      m = ctx.measureText(text);
      asc = m.actualBoundingBoxAscent || fs * 0.75;
      var left = m.actualBoundingBoxLeft || 0, right = m.actualBoundingBoxRight || m.width;
      var W = Math.min(4096, Math.ceil(left + right + 2 * pad));
      c.width = W; c.height = H;
      ctx.font = '400 ' + fs + 'px "' + font + '", Impact, sans-serif';
      ctx.fillStyle = '#000';
      ctx.fillText(text, pad + left, pad + asc);
      el.style.aspectRatio = W + ' / ' + H;
      metal(el, processMask(c), { speed: parseFloat(el.getAttribute('data-speed') || '1'), tint: el.getAttribute('data-tint') || '#E9D2A0', softness: 0.1, repetition: 2, shift: 0.3, distortion: 0.07, contour: 0.4, angle: 70 });
    };
    var safe = function () { try { go(); } catch (e) { el.classList.add('fx-failed'); } };
    if (document.fonts && document.fonts.load) document.fonts.load('400 100px "' + font + '"').then(safe, safe); else safe();
  }

  /* Logo texte du header en miroir façon Apple : chrome poli, mouvement lent, sans arc-en-ciel. */
  function initLogo(el) {
    var go = function () {
      var cs = getComputedStyle(el), PX = 6, PY = 4;
      var bw = el.offsetWidth, bh = el.offsetHeight;
      if (!bw || !bh) return;
      var k = Math.min(10, 220 / (bh + 2 * PX));
      var W = Math.round((bw + 2 * PY) * k), H = Math.round((bh + 2 * PX) * k);
      var mk = document.createElement('canvas'), ac = document.createElement('canvas');
      mk.width = ac.width = W; mk.height = ac.height = H;
      var c1 = mk.getContext('2d'), c2 = ac.getContext('2d');
      var font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + (parseFloat(cs.fontSize) * k) + 'px ' + cs.fontFamily;
      c1.font = c2.font = font; c1.fillStyle = c2.fillStyle = '#000';
      var asc = c1.measureText('R').fontBoundingBoxAscent || parseFloat(cs.fontSize) * k * 0.93;
      var box = el.getBoundingClientRect(), accentEl = el.querySelector('.logo__accent');
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), node, range = document.createRange();
      while ((node = walker.nextNode())) {
        var isAcc = accentEl && accentEl.contains(node);
        for (var i = 0; i < node.length; i++) {
          var ch = node.data[i]; if (!ch.trim()) continue;
          range.setStart(node, i); range.setEnd(node, i + 1);
          var r = range.getBoundingClientRect();
          var x = (r.left - box.left + PY) * k, y = (r.top - box.top + PX) * k + asc;
          c1.fillText(ch, x, y);
          if (isAcc) c2.fillText(ch, x, y);
        }
      }
      el.classList.add('fx-logo');
      metal(el, processMask(mk, c2.getImageData(0, 0, W, H).data), { speed: 0.35, maxPixels: 4e5, tint: '#FFFFFF', accent: document.body.getAttribute('data-logo-accent') || '#C9A35E', sharp: 1, gamma: 1.35, gain: 0.7, softness: 0.45, repetition: 1.4, shift: 0, distortion: 0, contour: 0.25, angle: 95 });
    };
    var safe = function () { try { go(); } catch (e) { el.classList.add('fx-failed'); } };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(safe, safe); else safe();
  }

  function boot() {
    if (document.body && document.body.hasAttribute('data-site-bg') && !document.querySelector('.site-bg')) {
      var bg = document.createElement('div');
      bg.className = 'site-bg'; bg.setAttribute('aria-hidden', 'true'); bg.setAttribute('data-fx-mesh', '');
      bg.setAttribute('data-colors', document.body.getAttribute('data-site-bg') || '#FFFFFF,#EEF0F1,#DADFE2,#F7F6F3,#C9D0D4,#F2F3F4');
      bg.setAttribute('data-speed', '0.12'); bg.setAttribute('data-grain', '0.05'); bg.setAttribute('data-distortion', '0.7');
      bg.setAttribute('data-swirl', '0.1'); bg.setAttribute('data-res', '0.35'); bg.setAttribute('data-max', '4e5'); bg.setAttribute('data-fps', '30');
      document.body.insertBefore(bg, document.body.firstChild);
    }
    [].forEach.call(document.querySelectorAll('[data-fx-mesh]'), function (el) {
      try { initMesh(el); } catch (e) { el.classList.add('fx-failed'); }
    });
    [].forEach.call(document.querySelectorAll('[data-fx-metal]'), initMetal);
    if (document.body && document.body.hasAttribute('data-logo-metal')) [].forEach.call(document.querySelectorAll('.header .logo__text'), initLogo);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
